import React from 'react';
import { styled } from '../../../stitches.config';

import Box from '../Box'
import Adslot from '../../Adslot'
import { Wrapper as Wrap } from "./ACommonStyles"
import { getPcsUrls } from "./AHelpers"

export default props => {
	const aspectRatio = { mobile: 2.4, desktop: 1.57 };
	const pcs = getPcsUrls(props.settings.settings?.pcs_background_mobile, props.settings.settings?.pcs_background_desktop);
	const isDesktop = window.innerWidth >= 996;

	return (
		<section className="container">
			<Warapper pcs={pcs}>
				<LeftColumn>
					<Box {...props} id="b1" type="BTextOnPicture" settings={props.settings.b1} classes="" />
					<div className="row">
						<div className="col-xs-12 col-md-6">
							{isDesktop ?
								<Box {...props} id="b2" type="BPhotoOnTop" settings={props.settings.b2} classes="" />
								:
								<Box {...props} id="b2" type="BPhotoOnLeft" settings={props.settings.b2} classes="" />
							}
						</div>
						<div className="col-xs-12 col-md-6">
							{isDesktop ?
								<Box {...props} id="b3" type="BPhotoOnTop" settings={props.settings.b3} classes="" />
								:
								<Box {...props} id="b3" type="BPhotoOnLeft" settings={props.settings.b3} classes="" />
							}
						</div>
					</div>
				</LeftColumn>
				{isDesktop && <Reklama>
					<Adslot name={props.settings.b4?.name} width={300} />
					<div id="hp-after-special2-rows-placeholder" className="hp-after-rows-placeholder"></div>
				</Reklama>}
			</Warapper>
		</section>
	);
}


const Warapper = styled(Wrap, {
	"@media (min-width: 992px)": {
		display: "flex",
		justifyContent: "start"
	}
});

const LeftColumn = styled("div", {
	"@media (min-width: 992px)": {
		width: "100%",
		maxWidth: "816px"
	}
});

const Reklama = styled("div", {
	width: "300px",
	margin: "12px auto",
	"@media (min - width: 992px)": {
		margin: "0 0 12px 24px"
	}
});
